import { render, staticRenderFns } from "./ConfirmRestorePage.vue?vue&type=template&id=69c5b8eb&scoped=true&"
import script from "./ConfirmRestorePage.vue?vue&type=script&lang=js&"
export * from "./ConfirmRestorePage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRestorePage.vue?vue&type=style&index=0&id=69c5b8eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c5b8eb",
  null
  
)

export default component.exports